<template>
    <b-modal scrollable b-modal :title="title" ref="mdlProrogaView" id="mdlProrogaView" size="md" @ok="onOk" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Inizio Permanenza:</label>
                    <span class="sa-data">{{ formatDateTime(jsonData.dataInizioPermanenza) }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Fine Permanenza:</label>
                    <span class="sa-data">{{ formatDateTime(jsonData.dataFinePermanenza) }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Giorni di Proroga</label>
                    <span class="sa-data">{{ jsonData.numeroGiorni }}</span>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Motivazione</label>
                    <span class="sa-data">{{ jsonData.note }}</span>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    props: {},
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            listKey: 0,
            pathResource: "/cotrichiesteproroga",
            id: null,
            idPropostaAccesso: null,
            title: "",
            jsonData: { idCot: "", note: "", numeroGiorni: "" },
        };
    },
    watch: {},
    methods: {
        init(id) {
            let me = this;
            me.id = id;
            // me.idPropostaAccesso = idPropostaAccesso;
            me.title = "Visualizza Proroga";
            me.loadData();
            me.$refs.mdlProrogaView.show();
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(link, null, me.resultResponse, me.resutlError);
        },
        resultResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.listKey++;
        },
        resutlError(error) {
            console.log(error);
        },
        close() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlProrogaView.hide();
        },
        onOk() {
            let me = this;
            me.$refs.mdlProrogaView.hide();
        },
    },
};
</script>
